import React from 'react'
import { Button } from 'components/ui'
import useLocaleText from 'components/useLocaleText'
import { useDashboardReview } from '../../hooks/useDashboardReview'
import { useExecutionText } from '../../hooks/useExecutionText'
import { reviewLiterals } from './literals'
import styles from './styles.module.css'
import { ExecutionSkeleton } from './ExecutionSkeleton'

export function ReviewLoadingState({ media = false }: { media?: boolean }) {
  const review = useDashboardReview()
  const t = useLocaleText(reviewLiterals)
  const execution = useExecutionText()
  if (review?.loading) return <ExecutionSkeleton media={media} />
  if (review?.error)
    return (
      <div className={styles.error} role="alert">
        {t.loadFailed}
        <Button variant="secondary" onClick={review.retry}>
          {execution.retry}
        </Button>
      </div>
    )
  return null
}
